<template>
  <div class="book-area">
    <h1 v-if="showType == 1">选择课本,复习生词</h1>
    <el-row v-if="showType == 1">
      <el-col :span="4" v-for="book in books" :key="book.id" class="col">
        <div @click="searcWord(book);">
          <el-card class="book" :body-style="{ padding: '10px' }" shadow="hover">
            <div class="bookname" slot="header" style="height: 30px">
              {{book.name}}
            </div>
            <el-image class="bookimage" :src="`https://awesome-platform.oss-cn-shanghai.aliyuncs.com${book['cover_img_url']}`"></el-image>
          </el-card>
        </div>
      </el-col>
    </el-row>



    <div v-if="showType == 2" style="margin: 0">
      <el-row>
        <el-col :span="2">
          <el-button round @click="showType = 1">返回</el-button>      
        </el-col>
        <el-col :span="20">
          <el-radio-group v-model="wordType" style="margin: 0px 0 0 0">
            <el-radio-button label="know">熟词({{book['know'].length}})</el-radio-button>
            <el-radio-button label="unsure">夹生词({{book['unsure'].length}})</el-radio-button>
            <el-radio-button label="miss">生词({{book['miss'].length}})</el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>
      
      <div style="width: 100%; margin: 20px 0 0 0">
        <el-row>
          <el-col :span="4" class="word-title-area">单词</el-col>
          <el-col :span="3" class="word-title-area">音标</el-col>
          <el-col :span="6" class="word-title-area">简义</el-col>
          <el-col :span="2" class="word-title-area">发音</el-col>
          <el-col :span="8" class="word-title-area">例句</el-col>
        </el-row>
      </div>
      <div v-for="item in book[`${wordType}`]" :key="item.id" style="width: 100%; margin: 10px 0 0 0%">
        <el-row>
          <el-col :span="4" class="word-info-area">{{item.content1}}</el-col>
          <el-col :span="3" class="word-info-area">{{item.content2}}</el-col>
          <el-col :span="6" class="word-info-area">{{item.content3}}</el-col>
          <el-col :span="2" class="word-info-area">
            <i class="el-icon-video-play" style="font-size: 1.22em" @click="playAudio(item.content7)"></i>
          </el-col>
          <el-col :span="8" class="word-info-area">{{item.content8}}</el-col>
        </el-row>
      </div>
      <p v-if="book[`${wordType}`].length == 0" style="margin-top: 100px;">暂无内容</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      baseApi: '/word-book',
      books: [],
      showType: 1,
      book: {},
      wordType: 'miss',
    }
  },
  computed: {
    ...mapGetters({
      info: 'getInfo',
    })
  },
  methods: {
    searcBook() {
      this.$fly.post(`${this.baseApi}/${this.info.id}`).then((res)=>{
        this.books = res;
      })
    },
    searcWord(book) {
      this.$fly.post(`${this.baseApi}/words`,{'studentAccountId.eLong':this.info.id,'bookId.eLong':book.id}).then((res)=>{
        this.book = res;
        window.console.log(res);
        this.showType = 2
      })
    },
    playAudio(url) {
      let audio = new Audio()
      audio.src = `https://awesome-platform.oss-cn-shanghai.aliyuncs.com/quick/v${url}`
      audio.play();
    }
  },
  created() {
    this.searcBook()
  }
}
</script>

<style scoped>
.book-area{
  padding: 40px 80px;
  overflow-y: hidden;
}
.word-info-area{
  background: #FFFFFF;
  margin: 0 5px;
  padding: 10px;
  font: 1.5em arial;
  height: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.word-title-area{
  margin: 0 5px;
  padding: 10px;
  font: 1.5em sans-serif;
}
.book{
  border-radius: 10px
}
.bookimage{
  width: 90%;
  border-radius: 10px
}
.col{
  padding: 15px
}
@media screen and (max-width: 1400px) { 
  .bookname{
    font-size: 10px;
  }
  .book{
    border-radius: 5px
  }
  .bookimage{
    border-radius: 5px
  }
  .col{
    padding: 5px
  }
  .word-title-area{
    margin: 0 2px;
  }
  .word-info-area{
    margin: 0 2px;
  }
}
</style>
